import { InjectionToken } from '@angular/core';
import type { SupabaseClient } from '@supabase/supabase-js';

export const AUTH_API_BASE_URL = new InjectionToken<string>(
	'AUTH_API_BASE_URL',
);
export const AUTH_SUPABASE_CLIENT = new InjectionToken<SupabaseClient>(
	'AUTH_SUPABASE_CLIENT',
);
